export default __webpack_public_path__ + "static/media/icon_age_restricted.8d9906f3.svg";